type HubspotPlantExternalReference = {
  externalSystem: 'hubspotPlant'
  externalID: string | null
}

// Multi-phase counterpart of buildHubspotExternalReferences: the assessment
// carries the HubSpot Plant ID, and the deal reference moves to installation
// phases. Never include a "hubspot" entry here — the deal reference belongs
// to the phases and must be left untouched.
export function buildHubspotPlantExternalReferences(
  hubspotPlantId: string | null | undefined
): [HubspotPlantExternalReference] | undefined {
  if (hubspotPlantId === undefined) return undefined
  return [{ externalSystem: 'hubspotPlant', externalID: hubspotPlantId }]
}
